// 服务商
import request from '@/utils/request'

// 获取服务商类目列表

export function getServiceCategoryList(params) {
  return request({
    url: '/serviceCategory/list',
    method: 'get',
    params: params
  })
}

// 服务商入驻申请
export function applyServicemcht(data) {
  return request({
    url: '/servicemcht/apply',
    method: 'PUT',
    data: data
  })
}
// 服务商入驻信息获取参数列表
export function getParamsList(params) {
  return request({
    url: '/paramset/list',
    method: 'get',
    params: params
  })
}


// 获取服务商申请详情

export function servicemchtAuditDetail(params) {
  return request({
    url: '/servicemcht/auditDetail',
    method: 'get',
    params: params
  })
}

// 获取服务列表
export function getSmchtList(params) {
  return request({
    url: '/smcht/list',
    method: 'get',
    params: params
  })
}
// 服务上架
export function smchtUp(params) {
  return request({
    url: `/smcht/put?id=${params}`,
    method: 'PUT',
  })
}

// 服务下架
export function smchtDown(data) {
  return request({
    url: `/smcht/down`,
    method: 'put',
    data
  })
}

// 添加服务
export function addSmcht(data) {
  return request({
    url: '/smcht/add',
    method: 'put',
    data: data
  })
}

// 编辑服务
export function updateSmcht(data) {
  return request({
    url: '/smcht/update',
    method: 'put',
    data
  })
}

// 获取服务详情

export function getSmchtDetails(params) {
  return request({
    url: '/smcht/detail',
    method: 'get',
    params: params
  })
}

// 删除服务
export function smchtDelete(data) {
  return request({
    url: '/smcht/del',
    method: 'PUT',
    data
  })
}

// 服务商首页数据
export function getSmchtHome(params) {
  return request({
    url: '/servicemcht/home',
    method: 'get',
    params: params
  })
}




// WEBPACK FOOTER //
// ./src/api/isp.js